import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const updateEmailOnSuiteFailureOnly = async ({ id, value }) => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteEmailOnFailureOnly&companyid=${user.companyid}&tsuid=${id}&value=${value}`,
  );
  return response.data;
};

const useUpdateEmailOnSuiteFailureOnly = () => {
  return useMutation({
    mutationFn: updateEmailOnSuiteFailureOnly,
  });
};

export default useUpdateEmailOnSuiteFailureOnly;